import React ,{useRef ,useEffect}from 'react';
import './TNA.scss'
import DynamicInputList from '../../software-dynamic-version-2/list-input-v-2';
import moment from 'moment'
import SecurityService from '../../security/security.service';
import BudgetingService from './TNA.service';
import TNAAdd from './TNA-add';
import DialogInput from '../../software-dynamic-version-2/popup-dialog-input-v-2';
import AuditTable from '../../audit-table/audit-table'
import securityService from '../../security/security.service';



const TNAInput = (props) => {
  
    let columns =[
        {  field: "EntryID",headerText:'ID',width:'120px',textAlign:'right' ,headerTextAlign:'center',other:[]},
        {  field: "EntryDate",headerText:'Entry Date',width:'130px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "ExportOrderNo",headerText:'Export Order No',width:'130px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
        {  field: "CustomerOrderNo",headerText:'Customer Order No',width:'130px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "CustomerName",headerText:'Customer Name',width:'130px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "ShipmentDate",headerText:'Shipment Date',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "ExportOrderDate",headerText:'Export Order Date',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "OrderQuantity",headerText:'Order Qty',width:'135px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0'}]},
        ]
        let detailsOfGrid = []
        const getDetails = (e)=>{
          console.log(e)
          detailsOfGrid = e
        }

        const listActionComplete = async (grid , args ,getListService ,selectedRow  ,setDataSourceState ,addUserLog,editUserLog)=>{
          console.log(args )
        console.log(getListService )
        console.log(selectedRow )
        if (args.requestType === 'beginEdit' || args.requestType === 'add') {
          }
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          getListService()

        }

        if (args.requestType == 'save'  && args.action  == 'add') {
          console.log(args)
          console.log(detailsOfGrid)
      
            BudgetingService.addWithDetail(
              {...args.data,  
                details :detailsOfGrid,
                UpdatedByUserID:SecurityService.getLoggedInUserId()}).then((res)=>{
              console.log(res)
              
              getListService()
              addUserLog('TNAMain','TNAMain','EntryID',{
                EntryDate:moment(args.data.EntryDate).format('DD-MMM-YY'),
                CustomerOrderNo:args.data.CustomerOrderNo
              })
              detailsOfGrid.map((res)=>{
                addUserLog('TNADetail','TNADetail','TNADetailRowID',{
                  TNADescDetail:res.TNADescDetail,
                  TNADate:moment(res.TNADate).format('DD-MMM-YY'),
                  TNAActualCompletionDate:moment(res.TNAActualCompletionDate).format('DD-MMM-YY')
                })

              })

             
              })
          
        }

        
        if (args.requestType == 'save'  && args.action  == 'edit') {
          BudgetingService.updateTNAMain(
            {...args.data,  
            }).then((response)=>{
              console.log(response);
              getListService()

              editUserLog('TNAMain',args.data.EntryID,'EntryID',{
                EntryDate:moment(args.data.EntryDate).format('DD-MMM-YY'),
                CustomerOrderNo:args.data.CustomerOrderNo
              })
            })
        }
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = false
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = false
    let  allowDataBound = false
    let  allowGridSum = true

       
        // Defines the  string
        // @default TNA${typeMode} 
        let ListSecurity='TNA'
        let AddSecurity='TNA'
        let EditSecurity='TNA'
        let DeleteSecurity='TNA'
        let ReportSecurity='TNA'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      let toolbarOptions =['Add','Edit',   
        {  text: `Delete`, tooltipText: "Delete", id: "DeleteWithDetail", disable:!SecurityService.canUserAccess('TNA')['Delete'] },        
        'Update','Cancel',
        {
          text: "Preview", tooltipText: "Preview", id: "TNAPreview", 
          disabled: !SecurityService.canUserAccess(ReportSecurity)
          ,mustSelectRow:true
       }
        ,'PDFExport','ExcelExport','Search','ColumnChooser'].filter(Boolean);
       ;
      


       const handleRedirectPreview = async (args) => {
         console.log(args)
         let reportServerPath = await securityService.ReportServerPath();
         console.log(reportServerPath);


        // Construct the URL with the parameters
        // http://asif-pc/ReportServer?
        // HS%2fTowelERP%2fExport%2fTNAPreview
        // &rs:Command=Render&rc:Toolbar=true&
        // EntryID=2&ExportOrderNo=0&ACodeCustomer=&PrintedByUserID=1
        //  EntryID=2&ExportOrderNo=0&ACodeCustomer=&PrintedByUserID=1
         const url = `${reportServerPath}%2fHS%2fTowelERP%2fExport%2fTNAPreview&rs:Command=Render&rc:Toolbar=true&EntryID=${args.EntryID || 0}&ExportOrderNo=${args.ExportOrderNo || 0}&ACodeCustomer=${args.ACodeCustomer || ''}&PrintedByUserID=${args.PrintedByUserID || 1}`;
        // Open the URL in a new tab and focus on it
        const newTab = window.open(url, '_blank');
        newTab.focus();
      };
      

       const dialogRef = useRef(null);
       const showDialog = (header,title,actions =['OK']) => {
         return new Promise((resolve) => {
         // Destroy existing dialog if any
         if (dialogRef.current) {
           dialogRef.current.destroy();
         }
         const okButtons = actions.map((action) => ({
           buttonModel: {
             content: action,
             cssClass: 'e-flat',
             isPrimary: action === 'OK',
           },
           click: (e) => {
             hideDialog();
             resolve(action);
           },
         }));
         // Create a new dialog instance
         dialogRef.current = new DialogInput({
           content: ()=>(<>{title}</>),
           header:header,
           width:'340px',
           showButtons: true,
           buttons:okButtons
         });
         // Show the dialog programmatically
         dialogRef.current.show();

       });

       };
     const hideDialog = () =>{
       if (dialogRef.current) {
       }
       dialogRef.current.hide();
       dialogRef.current.destroy();
       dialogRef.current = null; // Clean up reference after destruction
     }
      const toolbarClicking =  async (grid , args , selectedRow , getListService)=>{
        console.log(args)
        if(args?.item?.properties?.id == 'DeleteWithDetail'){
          if(selectedRow == undefined){
        await showDialog('WARNING' ,<span class="error-tooltip">Please select a row first!</span>)
      }else{
        let dialogResult  = await showDialog('Confirmation' ,<span class="error-success">Are you sure you want to delete?</span> , ['OK','CANCEL'])
        console.log(dialogResult)
      if(dialogResult == 'OK'){
        BudgetingService.delete(selectedRow.EntryID).then(async (res)=>{
        await  showDialog('ALERT' ,<span class="error-success">RECORD(S) DELETED SUCESSFULLY</span>)
          await getListService()
            AuditTable.auditDelete('UserInfo',selectedRow.EntryID,{
              EntryDate:moment(selectedRow.EntryDate).format('DD-MMM-YY'),
              CustomerOrderNo:selectedRow.CustomerOrderNo,
              CustomerName:selectedRow.CustomerName,
              ShipmentDate:moment(selectedRow.ShipmentDate).format('DD-MMM-YY'),
              ExportOrderDate:moment(selectedRow.ExportOrderDate).format('DD-MMM-YY'),
              OrderQuantity:selectedRow.OrderQuantity,
            })
          })
        }
        }
        }
        if(args?.item?.properties?.id == 'TNAPreview' && grid.selectedRowIndex != -1){
          
          console.log(grid.getSelectedRecords()[0])
          handleRedirectPreview(grid.getSelectedRecords()[0])
        
        }
       }
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'TNA' ,
                    TableID:'TNAID',
                   // Optional if Delete is Soft // TableSecurity:'TNADelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'TNA' ,TableID:'TNAID', Optional // TableSecurity:'TNADelete'}]
    let listDelete =  [{ TableName:'TNADetail' ,TableID:'EntryID'}];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
      let filterColumns = [];

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
        <DynamicInputList
        Id='TNA'
        ListTitle={`TNA  - List`}
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        DataSource:  ()=> BudgetingService.getTNAForList()
                        }]}
        DefaultSortedColumnName={'EntryID'}
        GridDialog={[
            {
                DialogType:'Self',
                // Dialog:<TNAAdd ShopID={SecurityService.getLoggedInUserId() == 0 ? SecurityService.getLoggedInUserId() : SecurityService.getLoggedInShopID()} />
                Dialog:<TNAAdd GridID={`TNA`} sendDetails={getDetails}/>
                // Dialog:<TNAAdd ShopID={1} /> 
                }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            AllowTemplate={allowTemplate}
            ToolbarOption={toolbarOptions}
            // AllowGrouping={allowGrouping}
            // AllowExcelExport={allowExcelExport}
            // AllowPdfExport={allowPdfExport} 
            // ShowColumnChooser={showColumnChooser}
            // AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            ListSecurity={ListSecurity}
            // AddSecurity={AddSecurity}
            // EditSecurity={EditSecurity}
            // DeleteSecurity={DeleteSecurity}
            // DefaultSortedColumnSort={DefaultSortedColumnSort}
            // FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            // GroupColumns={groupColumns} 
            // ListDelete={listDelete}
            // DeleteType={deleteType} 
            // GridEditSettingMode={gridEditSettingMode}
            // GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            AllowGridSum={allowGridSum}
            {...props}
            ></DynamicInputList>
            
            );
}



export default TNAInput;
